import menu from './modules/menu'
import stickifyNav from './modules/sticky_nav'
import stickify from './modules/stickify_element'
import filtersPopin from './modules/filtersPopin'
import filtersTabs from './modules/filtersTabs'
import filtersAjaxRequest from './modules/filtersAjax'
import revealUsp from './modules/reveal_usp'
import formValidator from './modules/form_validator'
import autocomplete from './modules/autocomplete'
import carList from './modules/carList'
import carSlider from './modules/carSlider'
import contactForms from './modules/contactForms'
import toolTips from './modules/tooltips'
import tracking from './modules/tracking'
import getUrlParameter from './modules/getUrlParams'
import setOrigin from './modules/setOrigin'
import nouiSlider from './modules/nouislider'
import carListSlider from './modules/carListSlider'
import carFilter from './modules/car_filter'
import r18ContestCarChoice from './modules/r18ContestCarChoice'
import campaignFormSwitcher from './modules/campaignFormSwitcher'
import configInformationLoader from "./modules/configInformationLoader";
import iframeResizerScroller from "./modules/iframeResizerScroller";
import TrackingFirstInteraction from "./modules/trackingFirstInteraction";
import MiniMessagePoster from './modules/miniMessagePoster';


window.addEventListener('DOMContentLoaded', () => {
  const prenomInput = document.getElementById("lastname");
  const nomInput = document.getElementById("firstname");
  const numInputs = document.querySelectorAll('.numOnly');
  if (nomInput) {
    nomInput.addEventListener('keydown',preventNumberInput);
  }
  if (prenomInput) {
    prenomInput.addEventListener('keydown',preventNumberInput);
  }

  numInputs.forEach(numInput => {
    numInput.addEventListener('keydown',checkNumberInput);
  })

  function preventNumberInput(e){
    var regex = new RegExp("^[A-zÀ-ú\- ]+$"),
        allowedTechnicalKeys = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Enter','Backspace','End','Home','Tab'],
        keyCode = e.keyCode || e.which;

    if (keyCode >= 96 && keyCode <= 105) {
      keyCode -= 48; // Numpad keys
    }

    var key = String.fromCharCode(keyCode)
    if (!regex.test(key) && !regex.test(event.key) && !allowedTechnicalKeys.includes(event.code) && event.key !== '-') {
      event.preventDefault();
      return false;
    }
  }
  function checkNumberInput(e){
    var regex = new RegExp("^[0-9]+$"),
        allowedTechnicalKeys = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Enter','Backspace','End','Home','Tab'],
        keyCode = e.keyCode || e.which;

    if (keyCode >= 96 && keyCode <= 105) {
      keyCode -= 48; // Numpad keys
    }

    var key = String.fromCharCode(keyCode)
    if (!regex.test(key) && !regex.test(e.key) && !allowedTechnicalKeys.includes(e.code)) {
      e.preventDefault();
      return false;
    }
  }

  let consentsToggler = document.querySelectorAll('.toggle-consents');
  consentsToggler.forEach(elem => {
    elem.addEventListener('click', function () {
      let target = '#' + elem.dataset.target;
      console.log('click on toggler, target : '+target);
      document.querySelector(target).classList.toggle('show-consents');
    })
  })

})


window.addEventListener('load', () => {
  /**
   * Polyfill ie11
   */

  // forEach method
  const polyForeach = _ => {
        if (typeof NodeList.prototype.forEach === 'function') return false
        NodeList.prototype.forEach = Array.prototype.forEach
      }
  polyForeach()

  // Remove method
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this)
      }
    }
  }

  // Includes method
  if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
      'use strict'
      if (typeof start !== 'number') {
        start = 0
      }

      if (start + search.length > this.length) {
        return false
      } else {
        return this.indexOf(search, start) !== -1
      }
    }
  }


  /**
   * Car Slider
   */

  const slider = document.querySelector(".thumbnail-car__image-container")
  if (slider) {
	  if (slider.dataset.sliderBehavior) {
		  if(slider.dataset.sliderBehavior === 'r18customcontest') {
			  r18ContestCarChoice()
		  }
	  }
	  else {
		  carSlider('.thumbnail-car__image')
	  }
  }

  const confirmSlider = document.querySelector(".confirmation__container--cars-slider")
  if (confirmSlider) {
    carSlider('.confirmation__container--cars')
  }

  tracking().initTracking()

  /**
   * Homepage
   */

  if (
      typeof _satellite != 'undefined' &&
      typeof _satellite.track === 'undefined') {
    _satellite.track = function (payload) {
      console.error('_satellite.track not defined', payload)
    }
  }

  if (typeof _satellite != 'undefined') _satellite.track('PageLoad') //Measure the number of screen viewed when page is dynamically loaded (artificial page view)

  const hasFilters = document.querySelector(".car-filters")
  const carGrid = document.querySelector(".car-lists")
  if (hasFilters) {
    carList().toggleCarCards()
    if (carGrid.clientHeight >= 550) {
      stickify(hasFilters)
    }
    filtersPopin().togglePopin()
    filtersTabs().toggleTabs()

    const ajax = new filtersAjaxRequest()
    ajax.loadFilteredContent()
    carList().setCardSize()

    window.addEventListener('resize', () => {
      carList().setCardSize()
    })
  }

  /**
   * Form
   */

  const hasForm = document.querySelector(".form")
  const hasContactForm = document.querySelector(".page__form-contact")
  const confirmPage = document.querySelector(".page__confirm")
  const closebandoBtn = document.querySelector(".bandeau-corona .close-btn")
  const notkg = document.body.classList.contains('notkg')

  if (hasForm) {
    // let rgpd_txt = document.querySelector("p.tt-rgpd").textContent.split(". ")

    // document.querySelector("p.tt-rgpd").innerHTML = `${rgpd_txt[0]}.`
    // document.querySelector(".tt-rgpd-boxes span").textContent = `${
    //   rgpd_txt[1]
    //   }`

    const form = document.querySelector(".page__form")


    if (form && !notkg ) {
      let form_type = form.getAttribute('data-form-type')
      if (typeof _satellite != 'undefined') _satellite.track('FormStarted')
      console.log('form started')

      switch (form_type) {

        // Measure the number of request sent with success after clicking on "Envoyez ma demande" (after the "Réservez un essai")
        case 'TDA':
          if (typeof _satellite != 'undefined') _satellite.track('TDAstarted')
          console.log("tda")
          break
        // Measure the number of clicks on the "VALIDEZ" button in the Demande d'offre webform
        case 'RFO':
          if (typeof _satellite != 'undefined') _satellite.track('RFOstarted')
          break
        // Measure the number of clicks on the "VALIDEZ" button in the Demande de Brochure webform
        case 'RFI':
          if (typeof _satellite != 'undefined') _satellite.track('RFIstarted')
          break
        // Mesurer le nombre de fois qu'un formulaire est validé avec succès au clic sur le CTA "Valider"
        case 'KMI':
          if (typeof _satellite != 'undefined') _satellite.track('ROIstarted')
          break
        case 'RFP':
          if (typeof _satellite != 'undefined') _satellite.track('RFPstarted')
          console.log('cmd-distance')
          break
      }
    }


    if (hasContactForm) {
      contactForms().toggleCustomerInformationBlock()
      contactForms().toggleBlock()
    }

    formValidator()
    autocomplete().launchAutocomplete()
  }


  if (confirmPage && !notkg ) {
    let form_type = confirmPage.getAttribute('data-form-type')
    switch (form_type) {

      // Measure the number of request sent with success after clicking on "Envoyez ma demande" (after the "Réservez un essai")
      case 'TDA':
        if (typeof _satellite != 'undefined') _satellite.track('TDAconfirmed')
        break
      // Measure the number of clicks on the "VALIDEZ" button in the Demande d'offre webform
      case 'RFO':
        if (typeof _satellite != 'undefined') _satellite.track('RFOconfirmed')
        break
      // Measure the number of clicks on the "VALIDEZ" button in the Demande de Brochure webform
      case 'RFI':
        if (typeof _satellite != 'undefined') _satellite.track('RFIconfirmed')
        break
      // Mesurer le nombre de fois qu'un formulaire est validé avec succès au clic sur le CTA "Valider"
      case 'KMI':
        if (typeof _satellite != 'undefined') _satellite.track('ROIconfirmed')
        break
      case 'C':
        console.log("RFC confirmed")
        if (typeof _satellite != 'undefined') _satellite.track('RFCconfirmed')
      case 'RFP':
        console.log("RFP confirmed")
        if (typeof _satellite != 'undefined') _satellite.track('RFPconfirmed')

    }
  }


  if (closebandoBtn) {

    let bandoHeight = document.querySelector('.bandeau-corona').clientHeight
    document.querySelector('.container').style.marginTop = bandoHeight + "px"
    document.querySelector('.bandeau-corona').classList.add("open")

    setTimeout(function () {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    }, 100)

    closebandoBtn.addEventListener('click', function () {

      document.querySelector('.bandeau-corona').classList.add('close')
      document.querySelector('.container').style.marginTop = 0
      document.querySelector('header .header-container').style.marginTop = 0
      document.querySelector('.bandeau-corona').classList.remove('open')


    })
  }


  const carBox = document.querySelector(".thumbnail-car")
  if (carBox) {
    revealUsp(carBox)
  }

  /**
   * Sticky bars
   */

  const navigation = document.querySelector(".header-container")
  if (navigation) {
    stickifyNav(navigation)
    menu().toggleMenu()
  }

  const isSticky = document.querySelector(".headline--sticky")
  if (isSticky) {
    stickify(isSticky)
  }

  /**
   * Tooltips
   */

  toolTips().toggleToolTips()

  // window.addEventListener("resize", () => {
  //   toolTips().toggleToolTips()
  // })

  /**
   * Tracking
   */

  // tracking().filterTracking()
  // tracking().carTracking()
  // tracking().formTypeTracking()

  /**
   * Car Slider
   */
  const carListSliders = document.querySelector(".car-slider")
  if (carListSliders) {

    const carSliders = document.querySelectorAll('.car-slider')
    const sliders = Array.from(carSliders).slice(0, 15)

    carListSlider(sliders)
    carFilter()
  }

  /*
   * Form Switcher
   */
  const campaignFormSwitcherItem = document.querySelectorAll('.select-activity input[type="radio"]')
  if (campaignFormSwitcherItem) {
    var campaignFormSwitch = new campaignFormSwitcher()
    campaignFormSwitch.initialize()
  }

  const isCustomConfig = document.getElementById('configId') ? document.getElementById('configId').value : null,
      isCustomConfigConfirm = document.querySelector('main.page__confirm') && document.querySelector('main[data-configId]'),
      isFixedVehicle = document.getElementById('vehicleModelCode') ? document.getElementById('vehicleModelCode').value : null;
  if (isCustomConfig || isFixedVehicle) {
    var configInformation = new configInformationLoader();
    configInformation.initialize();
  }


  const iframeResizerScroll = new iframeResizerScroller();
  if (document.body.classList.contains('noiFrameResizer') == false && document.body.classList.contains('notkg') == false) {
    iframeResizerScroll.initializeScrollTop();
  }


  // Listen dropdown for concours
  const mainELement = document.querySelector('main[data-form-version]')
  if (mainELement) {
    if (mainELement.dataset.formVersion == 'r18experiencetour' || mainELement.dataset.formVersion == 'boxexperience') {
      var optionConcours = document.querySelector('#product');
      optionConcours.addEventListener('change', e => {
        if (document.getElementById('car-card-name')) {
          document.getElementById('car-card-name').innerHTML = optionConcours.options[optionConcours.selectedIndex].text;
        }

        var campaignFormSwitch = new campaignFormSwitcher()
        campaignFormSwitch.initialize();
        campaignFormSwitch.switchVehicule(optionConcours.options[optionConcours.selectedIndex].getAttribute('data-id'), 'b2c');

        document.querySelector('main').setAttribute('data-id', optionConcours.options[optionConcours.selectedIndex].getAttribute('data-id'));
      })
    }
  }

  initPlaceholders();
  window.addEventListener('resize', function () {
    initPlaceholders();
  });
})
function initPlaceholders() {
  if (document.getElementsByName('new_zipcode')[0]) {
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (w < 800 && document.getElementsByName('new_zipcode')[0].placeholder == "Saississez votre code postal") {
      document.getElementsByName('new_zipcode')[0].placeholder = 'Code postal';
    } else {
      document.getElementsByName('new_zipcode')[0].placeholder = 'Saississez votre code postal';
    }
  }
}

MiniMessagePoster.initEventListeners()
